<template>
  <v-row align="center" class="outline pt-3" no-gutters>
    <v-container :class="popUpClasses">
      <v-row v-show="!success" v-if="!popUp" no-gutters>
        <v-col cols="12">
          <!-- <p>To find out first about my upcoming events and latest news, join my mailing list:</p> -->
          <h3>Join the food loving community</h3>
          <p>Sign up and receive Chef Naturelle's recipes, inspirations and latest news.</p>
        </v-col>
      </v-row>
      <v-form
        ref="form"
        v-model="valid"
        @submit="validate"
        @submit.prevent
        novalidate
      >
        <v-row v-show="!success" no-gutters>
          <v-col cols="12">
            <v-row class="mb-2" align="center" justify="start">
              <v-col cols="12" sm="5">
                <v-text-field
                  color="black"
                  label="First name"
                  type="name"
                  v-model="form.name"
                  :disabled="submitting"
                  :rules="rules.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="5">
                <v-text-field
                  color="black"
                  label="Email address"
                  type="email"
                  v-model="form.email"
                  :disabled="submitting"
                  :rules="rules.email"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" class="text-center">
                <v-btn
                  color="primary"
                  type="submit"
                  :disabled="!valid || submitting"
                >Subscribe</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-0" v-show="!success" align="center" justify="center" no-gutters>
          <v-col>
            <p class="terms">
              We respect your privacy. For details on how your personal information is used,
              please read our <a href="/privacy" target="_blank">privacy policy</a>.
            <!-- <p class="terms">You can -->
              <!-- <v-dialog v-model="unsubscribe">
                <template v-slot:activator="{ on }">
                  <a href="/unsubscribe" @click.prevent="unsubscribe = true" v-on="on">change your mind</a>
                </template>
                <v-card :img="bg">
                  <v-row align="center" justify="end" no-gutters>
                    <v-btn icon @click="unsubscribe = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-row>
                  <unsubscribe v-if="unsubscribe"></unsubscribe>
                </v-card>
              </v-dialog>
              at any time. For details on how your personal information is used, please read CHEF NATURELLE's
              <a href="/privacy" target="_blank">privacy policy</a>. -->
            </p>
          </v-col>
        </v-row>
        <v-row align="center" justify="start" class="thanks" no-gutters>
          <v-col v-show="success">
            <p>Thanks for subscribing!
              <v-btn color="primary" @click="reset()">OK</v-btn>
            </p>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-row>
</template>

<script>
import {
  VBtn,
  // VCard,
  VCol,
  VContainer,
  // VDialog,
  VForm,
  // VIcon,
  VRow,
  VTextField,
} from 'vuetify/lib'
import MailerService from '@/services/MailerService'
import {Validators} from '@/utils/validators'
// import Unsubscribe from '@/views/Unsubscribe'

export default {
  components: {
    // Unsubscribe,
    VBtn,
    // VCard,
    VCol,
    VContainer,
    // VDialog,
    VForm,
    // VIcon,
    VRow,
    VTextField,
  },
  computed: {
    popUpClasses() {
      return this.popUp ? ['popUp'] : []
    }
  },
  data: () => ({
    bg: require('@/assets/images/bg-white.jpg'),
    form: {
      email: '',
      name: '',
      termsAndConditions: false
    },
    rules: {
      email: [
        value => Validators.required(value) || 'Email is required.',
        value => Validators.email(value),
      ],
      name: [value => Validators.required(value) || 'Name is required.'],
    },
    submitting: false,
    success: false,
    unsubscribe: false,
    valid: false
  }),
  methods: {
    reset() {
      this.$refs.form.reset()
      this.submitting = false
      this.success = false
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.submitting = true

        MailerService
          .subscribe(this.form.email, this.form.name, ['newsletter'])
          .then(() => {
            this.submitting = false
            this.success = true
          });
      }
    }
  },
  props: {
    popUp: {
      default: false,
      type: Boolean,
    }
  }
}
</script>

<style scoped>
h3 {
  padding-bottom: 5px;
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 30px !important;
  color: rgba(0, 0, 0, 0.87) !important;
  text-transform: none !important;
}

p {
  margin-bottom: 5px;
}

p.terms {
  font-size: 15px;
}

.outline {
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  background: white;
}

.popUp {
  padding: 0 24px 24px 24px;
}
</style>
